import { type RelatedArticles } from "@app/types/Opensearch";
import Date from "@elements/Typography/Date";
import Heading from "@elements/Typography/Heading";
import { formatDate, formatTime } from "@helper/useDateFormat";
import { isArrayWithElements } from "@helper/utils";

export default function RelatedArticleNew({
  relatedArticles,
}: {
  relatedArticles: RelatedArticles;
}) {
  return (
    <div className="mb-6 lg:mb-8 border-b border-white-600 pb-3">
      <Heading
        Element="h6"
        className="font-primary font-semibold text-sm leading-[150%] border-t-2 border-red-100 text-red-100 py-[10px] mb-3"
        testId={`related-article-header`}
      >
        Laporan berkaitan
      </Heading>
      <div className="flex flex-col gap-3 lg:gap-6">
        {isArrayWithElements(relatedArticles) &&
          relatedArticles.map(({ id, urlPath, title, dateCreated }, index) => {
            return (
              <div
                key={id}
                className="flex flex-col gap-[10px]"
                data-testid={`related-article-wrapper-${index}`}
              >
                <a
                  data-testid={`related-article-title-${index}`}
                  href={urlPath}
                  className="hover:underline leading-[120%] lg:leading-[130%] font-secondary text-[16px] lg:text-[22px] text-black-800  font-medium"
                >
                  {title}
                </a>
                {dateCreated && (
                  <Date
                    date={formatDate(dateCreated)}
                    time={formatTime(dateCreated)}
                    variant={"or"}
                    className="text-[14px] font-semimedium leading-[150%] text-black-700"
                  />
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}
